import animatedCounter from "./counter";

export default function initAnimation() {

    countersAnimation();


}


/**
 * Animation de la section counters
 */
function countersAnimation() {
    const counters = document.querySelector('.counters');

    if (counters) {
        let alreadyUse = false;

        const options = {
            root: null,
            rootMargin: "6rem",
            threshold: -0.2
        };
        const observer = new IntersectionObserver((entries, options) => {
            if (entries[0].intersectionRatio > 0 && !alreadyUse) {
                gsap.from('#counters .info__title', {opacity: 0, y: -50, duration: 1});
                gsap.from('#counters .counters__info', {opacity: 0, y: -50, delay: 0.3, duration: 1, stagger: 0.1});
                setTimeout(animatedCounter, 600);
                console.log('les counters sont faites');
                // animatedCounter();
                alreadyUse = true;
            }
        });

        observer.observe(counters);
    }
}